<template>
  <div class="row">
<!-- thank you SMART-->
    <div class="col-sm-12 text-center m-t-20" v-if="type == 1">
      <div class="alert alert-light border-green" role="alert">
        <div class="smart-logo">
          <img src="/assets/img/success-checked-100.png" title="" style="width:100px;"/>
        </div>
        <h4 class="info-text">
          <strong>
            Thank you for registering for an account with Smart Currency Exchange.</strong
          >
          <p></p>
        </h4>
         <div class="text-center" role="alert">
          <p
            >We are processing your application and hope to have your account open shortly.
            <template  v-if="!isGBGVerified" >
            <br/>You will soon receive a welcome call from one of our currency experts who will provide all the information you need to plan your first transfer with us and answer any questions you may have.
            </template>
            </p>
        </div>
         <!-- <div class="alert alert-info text-center" role="alert">
          <b>
            Our team are available via telephone (<a href="tel:+442078980541" class="text-word-break">+44 20 7898 0541</a>) or <a href="mailto:info@smartcurrencyexchange.com" style="
text-decoration: none;" id="thankyou-email"><strong >email</strong></a> from
Monday to Friday, 8:30am to 6pm.</b>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "@/components/shared/mixinUtility";
export default {
  name: "MessageTemplate",
  props: ["type"],
   mixins: [mixin],
};
</script>
<style scoped>

.border-green {
  border: 2px solid #4AA848;
}
.m-t-20 {
  margin-top: 20px;
}

.smart-logo img {
  width: 170px;
}
</style>
